import React from 'react';
import Icon from '../../../components/AppIcon';

const AnalyticsFilters = ({ filters, onChange }) => {
  const handleDateChange = (field, value) => {
    onChange({ [field]: value });
  };

  const handleDepartmentChange = (e) => {
    onChange({ department: e?.target?.value });
  };

  const handleCategoryChange = (e) => {
    onChange({ featureCategory: e?.target?.value });
  };

  const handleQuickDateRange = (days) => {
    const dateTo = new Date()?.toISOString()?.split('T')?.[0];
    const dateFrom = new Date(Date.now() - days * 24 * 60 * 60 * 1000)?.toISOString()?.split('T')?.[0];
    onChange({ dateFrom, dateTo });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 mb-8">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={18} color="var(--color-primary)" />
        <h3 className="font-heading font-semibold text-base text-foreground">Analytics Filters</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div>
          <label className="caption text-xs font-medium text-muted-foreground mb-2 block">
            Date From
          </label>
          <input
            type="date"
            value={filters?.dateFrom || ''}
            onChange={(e) => handleDateChange('dateFrom', e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
          />
        </div>

        <div>
          <label className="caption text-xs font-medium text-muted-foreground mb-2 block">
            Date To
          </label>
          <input
            type="date"
            value={filters?.dateTo || ''}
            onChange={(e) => handleDateChange('dateTo', e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
          />
        </div>

        <div>
          <label className="caption text-xs font-medium text-muted-foreground mb-2 block">
            Department
          </label>
          <select
            value={filters?.department || ''}
            onChange={handleDepartmentChange}
            className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
          >
            <option value="">All Departments</option>
            <option value="HR">HR</option>
            <option value="Finance">Finance</option>
            <option value="Operations">Operations</option>
            <option value="Compliance">Compliance</option>
            <option value="IT">IT</option>
          </select>
        </div>

        <div>
          <label className="caption text-xs font-medium text-muted-foreground mb-2 block">
            Feature Category
          </label>
          <select
            value={filters?.featureCategory || ''}
            onChange={handleCategoryChange}
            className="w-full px-3 py-2 bg-background border border-border rounded-md text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
          >
            <option value="">All Categories</option>
            <option value="compliance">Compliance</option>
            <option value="payroll">Payroll</option>
            <option value="leave">Leave</option>
            <option value="workforce">Workforce</option>
            <option value="employee">Employee</option>
            <option value="contract">Contract</option>
            <option value="approval">Approval</option>
            <option value="audit">Audit</option>
            <option value="calendar">Calendar</option>
            <option value="policy">Policy</option>
          </select>
        </div>
      </div>
      <div className="flex items-center gap-2 mt-4 pt-4 border-t border-border">
        <span className="caption text-xs text-muted-foreground">Quick ranges:</span>
        <button
          onClick={() => handleQuickDateRange(7)}
          className="px-3 py-1 bg-muted hover:bg-muted/80 text-foreground rounded-md text-xs transition-smooth"
        >
          Last 7 days
        </button>
        <button
          onClick={() => handleQuickDateRange(30)}
          className="px-3 py-1 bg-muted hover:bg-muted/80 text-foreground rounded-md text-xs transition-smooth"
        >
          Last 30 days
        </button>
        <button
          onClick={() => handleQuickDateRange(90)}
          className="px-3 py-1 bg-muted hover:bg-muted/80 text-foreground rounded-md text-xs transition-smooth"
        >
          Last 90 days
        </button>
      </div>
    </div>
  );
};

export default AnalyticsFilters;
